import { FC } from 'react';
import cn from 'classnames';
import dibsCss from 'dibs-css';
import KlarnaIcon from 'dibs-icons/exports/legacy/KlarnaBadgeFilled';
import { PaymentMethodSelectOption } from '../PaymentMethodSelectOption';
import { usePaymentMethodSelectContext } from '../PaymentMethodSelectContext';

export const KlarnaPaymentMethod: FC = () => {
    const { selectedPaymentMethod, updateSelectedPaymentMethod, paymentMethodOptions } =
        usePaymentMethodSelectContext();

    const isSelected = selectedPaymentMethod?.paymentMethodType === 'KLARNA';

    function handleChange(): void {
        updateSelectedPaymentMethod({
            paymentMethodType: 'KLARNA',
            paymentProcessor: 'KLARNA',
        });
    }

    return (
        <PaymentMethodSelectOption
            isChecked={isSelected}
            onChange={handleChange}
            dataTn="payment-method-wireTransfer-input"
            name="payment-method"
            value="KLARNA-KLARNA"
            icon={<KlarnaIcon className={dibsCss.block} />}
            label={
                <div className={cn(dibsCss.flexGrow, dibsCss.sassyFontBodyMediumHeavy)}>Klarna</div>
            }
            content={isSelected ? paymentMethodOptions?.KLARNA?.selectedContent?.() : null}
        />
    );
};
